module.exports = "https://static.wmbcdn.com/uniweb/images/00ccb94d0d97ae781770baa97dab5fd9.svg";